import { DayScheduledScoring } from "./dayScheduledScoring";
import { FuelScoring } from "./fuelScoring";

export enum ScoringFrequency {
  Daily = 'daily',
  Never = "never",
  Weekly = "weekly",
}

export enum ScoringType {
  Default = 'default',
  Special = 'special',
}

export class Scoring {

  id: string | undefined;
  identify: string | undefined;
  description: string | undefined;
  chainId: string | undefined;
  createdByEmployeeId: string | undefined;
  startAt: string | undefined;
  endAt: string | undefined;
  frequency: ScoringFrequency | undefined;
  type: ScoringType | undefined;
  usageLimit: number | undefined;
  intervalInHours: number | undefined;
  isEnabled: boolean | undefined;
  isDefault: boolean | undefined;
  overlapsStandardScoring: boolean | undefined;
  createdAt: string | undefined;
  fuelScorings: FuelScoring[] = [];
  dayScheduledScorings: DayScheduledScoring[] = [];
  weekSchedual: DayScheduledScoring[] = [];
  customerTagIds: Array<string> = [];
  stationIds: Array<string> = [];
  startTime: Date | undefined;
  endTime: Date | undefined;
  isSchedule: boolean = false;
  customerIds: Array<string> = [];
  cityIds: Array<string> = [];
  selectsAllPlaces: boolean = false;
  hasNotification: boolean = false;
  notification: {
    title: string;
    body: string;
    pushNotification: boolean;
    pushMessage: string;
    sms: boolean;
    smsMessage: string;
    sendNow: boolean;
    sendAt: Date | null;
  } | undefined;

  static createScoring(value: Partial<Scoring>) {
    // A API espera weekSchedual no payload (validator)
    const weekSchedual = value.weekSchedual || value.dayScheduledScorings || [];

    const scoring: Partial<Scoring> = {
      type: value.type,
      description: value.description,
      chainId: value.chainId,
      fuelScorings: value.fuelScorings || [],
      weekSchedual,
      stationIds: value.stationIds || [],
      selectsAllPlaces: value.selectsAllPlaces,
      usageLimit: value.usageLimit,
      intervalInHours: value.intervalInHours,
      isSchedule: !!(value.startAt || value.endAt || value.frequency),
      startAt: value.startAt,
      endAt: value.endAt,
      frequency: value.frequency,
      customerTagIds: value.customerTagIds || [],
      customerIds: value.customerIds || [],
      cityIds: value.cityIds || [],
      overlapsStandardScoring: value.overlapsStandardScoring,
      hasNotification: value.hasNotification,
      notification: value.notification,
    };

    if (value.frequency === ScoringFrequency.Daily) {
      // No modo daily, os horários estão diretamente no formulário (value.startTime/endTime)
      // não dentro do weekSchedual
      scoring.startTime = value.startTime;
      scoring.endTime = value.endTime;
    }

    return scoring;
  }

  constructor(init?: Partial<Scoring>) {
    Object.assign(this, init);
  }
}
